import { render } from "./px-sticky-bar.vue?vue&type=template&id=dcc59e5e&scoped=true&ts=true"
import script from "./px-sticky-bar.vue?vue&type=script&lang=ts"
export * from "./px-sticky-bar.vue?vue&type=script&lang=ts"

import "./px-sticky-bar.vue?vue&type=style&index=0&id=dcc59e5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc59e5e"]])

export default __exports__